import { render, staticRenderFns } from "./lang-switcher.vue?vue&type=template&id=3d8a7ae0&scoped=true&"
import script from "./lang-switcher.vue?vue&type=script&lang=ts&"
export * from "./lang-switcher.vue?vue&type=script&lang=ts&"
import style0 from "./lang-switcher.vue?vue&type=style&index=0&id=3d8a7ae0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a7ae0",
  null
  
)

export default component.exports